import {
  Box,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Typography,
  Chip,
  Badge,
  Fade,
  Skeleton,
  CircularProgress,
} from "@mui/material";
import React, { useState, useRef, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import StarRating from "./StarRating";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add"; // Add this import
import ImageCarousel from "../../common/ImageCarousel";
import CustomButton from "../../common/Button/CustomButton";
import CartItemsContext from "../../../context/cartItems/CartItemsContext";
import LikedItemsContext from "../../../context/likedItems/LikedItemsContext";
import CustomisedSnackbar from "../../common/Snackbar/CustomisedSnackbar";
import AllProductContext from "../../../context/allProducts/AllProductsContext";
import "./styles.css";
const ProductCard = ({
  product,
  link,
  addToCartButton,
  showCarousel,
  fadeOutOnRemovingLike = false,
  showLikeButton = true,
  useMobileSize = false,
  showRating = true,
  showRatingNumber = true,
  showQuantity = false,
}) => {
  const initRating = {
    avg: 0,
    total: 0,
  };
  const [open, setOpen] = useState(false);
  const [liked, setLiked] = useState(false);
  const [rating, setRating] = useState(initRating);
  const [isHovered, setIsHovered] = useState(false);
  const [cartQuantity, setCartQuantity] = useState(0);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [isRemovingFromCart, setIsRemovingFromCart] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Add this state
  const snackbarMessage = useRef("");
  const cartItemsContext = useContext(CartItemsContext);
  const likedItemsContext = useContext(LikedItemsContext);
  const allProductContext = useContext(AllProductContext);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [loaded, setLoaded] = useState(false);

  // Screen size detection
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileScreen(window.innerWidth <= 768);
    };

    // Check initial screen size
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener("resize", checkScreenSize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  // Use detected mobile screen or prop value
  const effectiveUseMobileSize = isMobileScreen || useMobileSize;

  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const loadImg = new Image();
      loadImg.src = image;
      // wait 1 second to simulate loading time
      loadImg.onload = () =>
        // setTimeout(() => {
        {
          // console.log("resolve:", image, ", proId:", product.id);
          resolve(image);
        };
      // }, 1000);

      loadImg.onerror = (err) => reject(err);
    });
  };
  useEffect(() => {
    const allProductsArr = allProductContext.state;

    // console.log(
    //   "Product Card =====> allProductContext.state: ",
    //   allProductsArr
    // );
    setRating(initRating);
    if (allProductsArr !== null && allProductsArr.length > 0) {
      const prod = allProductsArr.filter((item) => {
        return item.id === product.id;
      });
      if (!prod || prod.length === 0) return;
      if (prod[0].ratings && prod[0].ratings.length > 0) {
        const p_rating_average =
          prod[0].ratings.reduce((a, b) => a + b, 0) / prod[0].ratings.length;
        const rating_average = Math.round(p_rating_average / 0.5) * 0.5;
        const setData = {
          avg: rating_average,
          total: prod[0].ratings.length,
        };
        // console.log("UPDATE PRO RATING====>", setData);
        setRating({
          ...setData,
        });
      } else {
        setRating({ ...initRating });
      }
    }
  }, [allProductContext.state]);

  useEffect(() => {
    setLiked(false);
    if (
      likedItemsContext.state !== null &&
      likedItemsContext.state.length > 0
    ) {
      const likedItemsArray = likedItemsContext.state;
      const indexOfProductInLikedItems = likedItemsArray.findIndex(
        (a) => a.id === product.id
      );
      // console.log("likedItemsArray:", likedItemsArray.length);

      if (indexOfProductInLikedItems !== -1) {
        setLiked(true);
      }
    }
  }, [likedItemsContext.state]);

  useEffect(() => {
    if (!product || !product.images || product.images.length === 0) return;
    loadImage(product.images[0].url)
      .then(() => setLoaded(true))
      .catch((err) => setLoaded(true));
    setDeleteItemId(null);
    setLiked(false);
    if (likedItemsContext.state !== null) {
      const likedItemsArray = likedItemsContext.state;
      const indexOfProductInLikedItems = likedItemsArray.findIndex(
        (a) => a.id === product.id
      );
      if (indexOfProductInLikedItems !== -1) {
        setLiked(true);
      }
    }
    if (product.ratings && product.ratings.length > 0) {
      const p_rating_average =
        product.ratings.reduce((a, b) => a + b, 0) / product.ratings.length;
      const rating_average = Math.round(p_rating_average / 0.5) * 0.5;
      const setData = {
        avg: rating_average,
        total: product.ratings.length,
      };
      // console.log("UPDATE PRO RATING====>", setData);
      setRating({
        ...setData,
      });
    } else {
      setRating({ ...initRating });
    }
  }, [product.id]);
  useEffect(() => {
    if (deleteItemId !== null) {
      setTimeout(() => {
        setOpen(true);
      }, 500);
    }
  }, [deleteItemId]);

  const handleAddToCart = () => {
    if (isAddingToCart) return; // Prevent action if disabled

    setIsAddingToCart(true); // Disable button
    setTimeout(() => setIsAddingToCart(false), 1000); // Re-enable after 1 second

    const tempCartItems =
      cartItemsContext.state !== null ? cartItemsContext.state : [];

    const indexOfProductInCart = tempCartItems.findIndex(
      (a) => a.id === product.id
    );

    // Check if this product already added to cart

    // console.log("indexOfProductInCart:", indexOfProductInCart);
    if (indexOfProductInCart !== -1) {
      const products_ = [...tempCartItems];
      products_.splice(indexOfProductInCart, 1);
      const tempItemCount = tempCartItems[indexOfProductInCart].quantity;
      cartItemsContext.setState([
        { ...product, quantity: tempItemCount + 1 },
        ...products_,
      ]);
      snackbarMessage.current =
        "1 more unit of " + product.title + " added to cart";
    } else {
      snackbarMessage.current = "1 unit of " + product.title + " added to cart";
      cartItemsContext.setState([
        { ...product, quantity: 1 },
        ...tempCartItems,
      ]);
    }
    setSnackbarSeverity("success"); // Set green color for add actions
    setOpen(true);
  };

  // Add new function to handle removing items from cart
  const handleRemoveFromCart = () => {
    if (isRemovingFromCart) return; // Prevent action if disabled

    setIsRemovingFromCart(true); // Disable button
    setTimeout(() => setIsRemovingFromCart(false), 1000); // Re-enable after 1 second

    const tempCartItems =
      cartItemsContext.state !== null ? cartItemsContext.state : [];

    const indexOfProductInCart = tempCartItems.findIndex(
      (a) => a.id === product.id
    );

    if (indexOfProductInCart !== -1) {
      const products_ = [...tempCartItems];
      const currentQuantity = tempCartItems[indexOfProductInCart].quantity;

      if (currentQuantity > 1) {
        // Decrease quantity by 1
        products_.splice(indexOfProductInCart, 1);
        cartItemsContext.setState([
          { ...product, quantity: currentQuantity - 1 },
          ...products_,
        ]);
        snackbarMessage.current =
          "1 unit of " + product.title + " removed from cart";
      } else {
        // Remove item completely if quantity is 1
        products_.splice(indexOfProductInCart, 1);
        cartItemsContext.setState([...products_]);
        snackbarMessage.current = product.title + " removed from cart";
      }
      setSnackbarSeverity("error"); // Set red color for remove actions
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleLikeItem = () => {
    const likedItemsArray = likedItemsContext.state;
    if (likedItemsArray !== null) {
      const indexOfProductInLikedItems = likedItemsArray.findIndex(
        (a) => a.id === product.id
      );
      if (indexOfProductInLikedItems !== -1) {
        fadeOutOnRemovingLike
          ? setDeleteItemId(product.id)
          : setDeleteItemId(null);
        snackbarMessage.current = product.title + " removed from wishlist";

        setLiked(false);
        likedItemsArray.splice(indexOfProductInLikedItems, 1);
        setTimeout(() => {
          likedItemsContext.setState([...likedItemsArray]);
        }, 500);
        setSnackbarSeverity("error"); // Set red color for remove from wishlist
      } else {
        snackbarMessage.current = product.title + " added to wishlist";
        likedItemsContext.setState([product, ...likedItemsArray]);
        setLiked(true);
        setSnackbarSeverity("success"); // Set green color for add to wishlist
      }
    } else {
      snackbarMessage.current = product.title + " added to wishlist";
      likedItemsContext.setState([product]);
      setLiked(true);
      setSnackbarSeverity("success"); // Set green color for add to wishlist
    }
    if (!fadeOutOnRemovingLike) setOpen(true);
  };
  // Add new useEffect to track cart quantity
  useEffect(() => {
    const tempCartItems = cartItemsContext.state || [];
    const cartItem = tempCartItems.find((item) => item.id === product.id);
    setCartQuantity(cartItem ? cartItem.quantity : 0);
  }, [cartItemsContext.state, product.id]);

  const discountPercentage = Math.ceil(
    ((product.maxPrice - product.listPrice) / product.maxPrice) * 100
  );

  const savings = Math.ceil(product.maxPrice - product.listPrice);

  return (
    <Fade in={deleteItemId !== product.id} timeout={500}>
      <Card
        sx={{
          position: "relative",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          borderRadius: 3,
          overflow: "hidden",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          cursor: "pointer",
          // Disable touch highlight on mobile devices
          WebkitTapHighlightColor: "transparent",
          WebkitTouchCallout: "none",
          WebkitUserSelect: "none",
          KhtmlUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          userSelect: "none",
          // Additional mobile touch fixes
          "@media (max-width: 768px)": {
            "&:focus": {
              outline: "none",
            },
            "&:active": {
              backgroundColor: "transparent",
            },
          },
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Savings Badge */}
        {!effectiveUseMobileSize && savings > 0 && loaded && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 3,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <Chip
              label={`Save ₹${savings}`}
              size="small"
              sx={{
                background: "linear-gradient(45deg, #4caf50, #2e7d32)",
                color: "white",
                fontWeight: 600,
                fontSize: "0.75rem",
                boxShadow: "0 2px 8px rgba(76, 175, 80, 0.3)",
                animation: "pulse-green 2s infinite",
                borderRadius: 0,
                opacity: 0.9,
              }}
            />
          </Box>
        )}

        {/* Quantity Badge */}
        {showQuantity && loaded && (
          <Chip
            label={`Qty: ${product.quantity}`}
            size="small"
            variant="outlined"
            sx={{
              position: "absolute",
              top: 12,
              right: showLikeButton ? 60 : 12,
              zIndex: 2,
              backgroundColor: "rgba(255,255,255,0.9)",
              backdropFilter: "blur(10px)",
              fontWeight: 500,
            }}
          />
        )}

        {/* Like Button */}
        {showLikeButton && loaded && (
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              handleLikeItem();
            }}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 2,
              backgroundColor: "rgba(255,255,255,0.9)",
              backdropFilter: "blur(10px)",
              width: 40,
              height: 40,
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,1)",
                transform: "scale(1.1)",
              },
            }}
          >
            {liked ? (
              <FavoriteIcon sx={{ color: "#e91e63", fontSize: 20 }} />
            ) : (
              <FavoriteBorderIcon
                sx={{ color: "text.secondary", fontSize: 20 }}
              />
            )}
          </IconButton>
        )}

        {/* Product Image */}
        <Box
          component={Link}
          to={link}
          sx={{
            position: "relative",
            height: effectiveUseMobileSize ? 180 : 220,
            overflow: "hidden",
            textDecoration: "none",
          }}
        >
          {showCarousel && loaded ? (
            <ImageCarousel
              showIndicators={false}
              ImagesArr={product.images.map((a) => a.url)}
              autoPlayOnHover={true}
              sx={{ width: "100%", height: "100%" }}
            />
          ) : loaded ? (
            <CardMedia
              component="img"
              image={product.images[0]?.url}
              alt={product.title}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transition: "transform 0.3s ease",
                transform: isHovered ? "scale(1.05)" : "scale(1)",
              }}
            />
          ) : (
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{ transform: "scale(1)" }}
            />
          )}

          {/* Quick Add to Cart Overlay - Always Visible */}
          {/* Remove this entire section */}
        </Box>

        {/* Product Details */}
        <CardContent
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            p: 2,
            "&:last-child": { pb: 2 },
          }}
        >
          {/* Product Title */}
          <Box component={Link} to={link} sx={{ textDecoration: "none" }}>
            <Typography
              variant={effectiveUseMobileSize ? "body2" : "body1"}
              sx={{
                fontWeight: 600,
                color: "text.primary",
                lineHeight: 1.3,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                // minHeight: useMobileSize ? "2.6em" : "3.2em",
                // "&:hover": {
                //   color: "primary.main",
                // },
              }}
            >
              {loaded ? product.title : <Skeleton />}
            </Typography>
          </Box>

          {/* Rating */}
          {showRating && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {loaded ? (
                <StarRating
                  rating={rating.avg}
                  showTotalNumber={rating.total}
                  showRatingNumber={showRatingNumber}
                />
              ) : (
                <Skeleton width="60%" height={20} />
              )}
            </Box>
          )}

          {/* Price Section */}
          <Box sx={{ mt: "auto" }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
            >
              <Typography
                variant={effectiveUseMobileSize ? "h6" : "h5"}
                sx={{
                  fontWeight: 700,
                  color: "primary.main",
                }}
              >
                {loaded ? `₹${product.listPrice}` : <Skeleton width="40%" />}
              </Typography>

              {!showQuantity &&
                loaded &&
                product.maxPrice > product.listPrice && (
                  <Typography
                    variant="body2"
                    sx={{
                      textDecoration: "line-through",
                      color: "text.secondary",
                      fontWeight: 500,
                    }}
                  >
                    ₹{product.maxPrice}
                  </Typography>
                )}
              {/* Discount Percentage Badge - moved here */}
              {!effectiveUseMobileSize && discountPercentage > 0 && loaded && (
                <Chip
                  label={`${discountPercentage}% OFF`}
                  size="small"
                  sx={{
                    background: "linear-gradient(45deg, #ff6b6b, #ee5a24)",
                    color: "white",
                    fontWeight: 600,
                    fontSize: "0.7rem",
                    height: "20px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 8px rgba(255, 107, 107, 0.3)",
                    animation: "pulse-red 2s infinite",
                  }}
                />
              )}
            </Box>
            {effectiveUseMobileSize && savings > 0 && loaded && (
              <Box
                sx={{
                  zIndex: 3,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Chip
                  label={`Save ₹${savings}`}
                  size="small"
                  sx={{
                    background: "linear-gradient(45deg, #4caf50, #2e7d32)",
                    color: "white",
                    fontWeight: 600,
                    fontSize: "0.75rem",
                    boxShadow: "0 2px 8px rgba(76, 175, 80, 0.3)",
                    animation: "pulse-green 2s infinite",
                  }}
                />
              </Box>
            )}
            {showQuantity && loaded && (
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  textDecoration: "line-through",
                }}
              >
                ₹{product.maxPrice}
              </Typography>
            )}
          </Box>

          {/* Add to Cart Controls - Moved below price section */}
          {addToCartButton && loaded && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: useMobileSize ? 1.5 : 2,
                mt: 1.5,
                borderRadius: "10px",
                border: "1px solid darkgreen",
              }}
            >
              {cartQuantity > 0 ? (
                // Show add/remove icons when item is in cart
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    padding: "4px",
                  }}
                >
                  {/* Remove button */}
                  <IconButton
                    disabled={isRemovingFromCart}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (!isRemovingFromCart) {
                        handleRemoveFromCart();
                      }
                    }}
                    sx={{
                      color: "red",
                      transition: "all 0.2s ease",
                      cursor: isRemovingFromCart ? "not-allowed" : "pointer",
                    }}
                  >
                    {isRemovingFromCart ? (
                      <CircularProgress
                        size={effectiveUseMobileSize ? 16 : 18}
                        sx={{ color: "red" }}
                      />
                    ) : (
                      <RemoveIcon
                        sx={{ fontSize: effectiveUseMobileSize ? 18 : 20 }}
                      />
                    )}
                  </IconButton>

                  {/* Quantity Display */}
                  <Typography
                    variant={effectiveUseMobileSize ? "body2" : "body1"}
                    sx={{
                      fontWeight: 600,
                      minWidth: "40px",
                      textAlign: "center",
                    }}
                  >
                    {cartQuantity}
                    {effectiveUseMobileSize
                      ? ""
                      : cartQuantity > 1
                      ? " units in cart"
                      : " unit in cart"}
                    {/* if more than 1 then show units, otherwise unit */}
                  </Typography>

                  {/* Add button */}
                  <IconButton
                    disabled={isAddingToCart}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleAddToCart();
                    }}
                    sx={{
                      color: "darkgreen",
                      // "&:disabled": {
                      //   color: "rgba(255, 255, 255, 0.7)",
                      // },
                      transition: "all 0.2s ease",
                      cursor: isAddingToCart ? "not-allowed" : "pointer",
                    }}
                  >
                    {isAddingToCart ? (
                      <CircularProgress
                        size={effectiveUseMobileSize ? 16 : 18}
                        sx={{ color: "darkgreen" }}
                      />
                    ) : (
                      <AddIcon
                        sx={{ fontSize: effectiveUseMobileSize ? 18 : 20 }}
                      />
                    )}
                  </IconButton>
                </Box>
              ) : (
                // Show "Add to Cart" button when item is not in cart
                <CustomButton
                  variant="outlined"
                  size="small"
                  disabled={isAddingToCart}
                  fullWidth
                  startIcon={
                    isAddingToCart ? (
                      <CircularProgress
                        size={effectiveUseMobileSize ? 14 : 16}
                        sx={{ color: "rgba(255, 255, 255, 0.7)" }}
                      />
                    ) : (
                      <ShoppingCartIcon
                        sx={{ fontSize: effectiveUseMobileSize ? 16 : 18 }}
                      />
                    )
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleAddToCart();
                  }}
                  sx={{
                    fontWeight: 600,
                    borderRadius: 2,
                    py: effectiveUseMobileSize ? 1 : 1.2,
                    fontSize: effectiveUseMobileSize ? "0.75rem" : "0.875rem",
                    "&:disabled": {
                      backgroundColor: "rgba(0, 0, 0, 0.12)",
                      color: "rgba(0, 0, 0, 0.26)",
                    },
                    cursor: isAddingToCart ? "not-allowed" : "pointer",
                    transition: "all 0.2s ease",
                  }}
                >
                  {isAddingToCart
                    ? "Adding..."
                    : effectiveUseMobileSize
                    ? "Add"
                    : "Add to Cart"}
                </CustomButton>
              )}
            </Box>
          )}
        </CardContent>

        {/* <CustomisedSnackbar
          message={snackbarMessage.current}
          severity={snackbarSeverity} // Use dynamic severity instead of hardcoded "success"
          open={open}
          handleClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={4000}
        /> */}
      </Card>
    </Fade>
  );
};

export default ProductCard;
